// extracted by mini-css-extract-plugin
export default {"calenderDesign":"Index_calenderDesign__e0cyp","calenderitself":"Index_calenderitself__aFpGE"};